import { render, staticRenderFns } from "./moblienavMenu.vue?vue&type=template&id=e5601216&scoped=true&"
import script from "./moblienavMenu.vue?vue&type=script&lang=js&"
export * from "./moblienavMenu.vue?vue&type=script&lang=js&"
import style0 from "./moblienavMenu.vue?vue&type=style&index=0&id=e5601216&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5601216",
  null
  
)

export default component.exports